/**
 * A shape's outline, as an SVG path in its own local box.
 *
 * SVG rather than HTML boxes because a chain of four hundred parties is
 * read at 16% zoom and back up to 400%, and only vector geometry stays
 * honest across that range — a CSS border rounds to nothing at one end
 * and to a slab at the other.
 */
export function shapePath(type, w, h) {
  const r = Math.min(12, w / 4, h / 4);
  switch (type) {
    case 'rounded':
      return `M ${r} 0 H ${w - r} A ${r} ${r} 0 0 1 ${w} ${r} V ${h - r}`
        + ` A ${r} ${r} 0 0 1 ${w - r} ${h} H ${r} A ${r} ${r} 0 0 1 0 ${h - r} V ${r}`
        + ` A ${r} ${r} 0 0 1 ${r} 0 Z`;
    case 'ellipse':
      return `M 0 ${h / 2} A ${w / 2} ${h / 2} 0 1 0 ${w} ${h / 2}`
        + ` A ${w / 2} ${h / 2} 0 1 0 0 ${h / 2} Z`;
    case 'diamond':
      return `M ${w / 2} 0 L ${w} ${h / 2} L ${w / 2} ${h} L 0 ${h / 2} Z`;
    case 'octagon': {
      const cx = w * 0.293;
      const cy = h * 0.293;
      return `M ${cx} 0 H ${w - cx} L ${w} ${cy} V ${h - cy} L ${w - cx} ${h}`
        + ` H ${cx} L 0 ${h - cy} V ${cy} Z`;
    }
    case 'hexagon': {
      const c = w * 0.25;
      return `M ${c} 0 H ${w - c} L ${w} ${h / 2} L ${w - c} ${h} H ${c} L 0 ${h / 2} Z`;
    }
    case 'parallelogram': {
      const c = w * 0.22;
      return `M ${c} 0 H ${w} L ${w - c} ${h} H 0 Z`;
    }
    case 'cylinder': {
      const ry = Math.min(h * 0.16, 22);
      return `M 0 ${ry} A ${w / 2} ${ry} 0 0 0 ${w} ${ry} V ${h - ry}`
        + ` A ${w / 2} ${ry} 0 0 1 0 ${h - ry} Z`;
    }
    case 'note': {
      const fold = Math.min(22, w / 4, h / 4);
      return `M 0 0 H ${w - fold} L ${w} ${fold} V ${h} H 0 Z`;
    }
    case 'text':
      return '';
    case 'rectangle':
    default:
      return `M 0 0 H ${w} V ${h} H 0 Z`;
  }
}

/** Dash arrays, in stroke widths so they scale with the line. */
export function dashOf(style, strokeWidth) {
  const unit = Math.max(1, strokeWidth);
  if (style === 'dashed') return `${unit * 4} ${unit * 3}`;
  if (style === 'dotted') return `${unit} ${unit * 2}`;
  return undefined;
}
